<!-- https://freefrontend.com/bootstrap-timelines/ -->
<!-- https://www.bootdey.com/snippets/view/dark-timeline#html -->

<div class="timeline border-top">
  @if (model) {
    @for (tEvent of model; track tEvent) {
      <div class="timeline-row">
        <div class="timeline-time">
          {{tEvent.createdTime}}<small>{{tEvent.createdDate}}</small>
        </div>
        <div class="timeline-content">
          <i class="icon-attachment"></i>
          <h4>{{tEvent.title}}</h4>
          <p>{{tEvent.description}}</p>
          @if (tEvent.message) {
            <p class="blockquote-footer">{{tEvent.message}}</p>
          }
          <!-- <div class="thumbs">
          <img class="img-fluid rounded" src="https://bootdey.com/img/Content/avatar/avatar1.png" alt="Maxwell Admin">
          <img class="img-fluid rounded" src="https://bootdey.com/img/Content/avatar/avatar2.png" alt="Maxwell Admin">
          <img class="img-fluid rounded" src="https://bootdey.com/img/Content/avatar/avatar3.png" alt="Maxwell Admin">
        </div> -->
        <div class="">
          <span class="badge badge-pill">{{tEvent.createdBy}}</span>
        </div>
      </div>
    </div>
  }
} @else {
  <div class="timeline-row">
    <div class="timeline-content">
      <p class="m-0">Loading...</p>
    </div>
  </div>
}


</div>